import Sanu from './sanu'

export default Sanu
